import { render } from "./page-detail.vue?vue&type=template&id=9f027212&scoped=true"
import script from "./page-detail.vue?vue&type=script&lang=js"
export * from "./page-detail.vue?vue&type=script&lang=js"

import "./page-detail.vue?vue&type=style&index=0&id=9f027212&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9f027212"

export default script